import { api, apiTags } from '~shared/api/origin';

import type {
	CancelSubscriptionApiRequest,
	GetSubscriptionBenefitsApiResponse,
	GetSubscriptionsApiResponse,
} from './types';

export const {
	util,
	useGetSubscriptionsQuery,
	useCancelSubscriptionMutation,
	useGetSubscriptionBenefitsQuery,
} = api.injectEndpoints({
	endpoints: (build) => ({
		getSubscriptions: build.query<GetSubscriptionsApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/benefits/${id}/subscriptions/actual`,
			}),
			providesTags: [apiTags.subscriptions],
		}),

		getSubscriptionBenefits: build.query<
			GetSubscriptionBenefitsApiResponse,
			{ id: string }
		>({
			query: ({ id }) => ({
				url: `/ai/chats/${id}/subscription-benefits/premium`,
			}),
		}),

		cancelSubscription: build.mutation<
			undefined,
			{ id: string; body: CancelSubscriptionApiRequest }
		>({
			query: ({ id, body }) => ({
				url: `/benefits/${id}/subscriptions/cancel`,
				method: 'POST',
				body,
			}),
			async onQueryStarted({ id, body }, { dispatch, queryFulfilled }) {
				try {
					await queryFulfilled;
					dispatch(
						util.updateQueryData('getSubscriptions', { id }, (draft) => {
							const item = draft.subscriptions.find(
								(item) => item.sku === body.sku
							);
							if (!item) return;
							item.cancelDate = item.endDate;
						})
					);
				} catch {}
			},
		}),
	}),
});
